// URL de la API. En local se puede cambiar con REACT_APP_API_URL en .env.local
// (ej: http://localhost:8000/api). Si no está definida, usa producción.
export const API_URL =
  process.env.REACT_APP_API_URL || 'https://pacifictourcr-production.up.railway.app/api';
